export class Region{
    public regionId:any;
    public regionName:string;
    public regionCode:string;
}